// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Njem","clinicsSelect":"styles_clinicsSelect__14NEN"};